import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import React from 'react';
import css from './GiftsMisc.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

var Item = function Item(_ref) {
  var image = _ref.image,
      copy = _ref.copy,
      title = _ref.title,
      url = _ref.url;
  return /*#__PURE__*/_jsx("li", {
    className: css.item,
    children: /*#__PURE__*/_jsxs("a", {
      className: css.link,
      href: url,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.itemImage,
        children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
          sizes: [480, 600, 900],
          wrap: false
        }))
      }), /*#__PURE__*/_jsx("h3", {
        className: css.itemTitle,
        dangerouslySetInnerHTML: {
          __html: title
        }
      }), /*#__PURE__*/_jsx("p", {
        className: css.itemCopy,
        dangerouslySetInnerHTML: {
          __html: copy
        }
      })]
    })
  });
};

Item.propTypes = {
  image: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  copy: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

var GiftsMisc = function GiftsMisc(_ref2) {
  var title = _ref2.title,
      items = _ref2.items;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("h2", {
      className: css.title,
      dangerouslySetInnerHTML: {
        __html: title
      }
    }), /*#__PURE__*/_jsx("ul", {
      className: css.items,
      children: items.map(function (item) {
        return /*#__PURE__*/_createElement(Item, _objectSpread(_objectSpread({}, item), {}, {
          key: item.title
        }));
      })
    })]
  });
};

GiftsMisc.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape(Item.propTypes)).isRequired
};
export default GiftsMisc;